import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { Text } from "@cars24/turbo-web/lib/text";
import StateChallanInfoCard from "../state-challan-info-card";

const StateEChallanTransaction = ({ eChallanTransaction = {} }) => {

    const { tokens } = useTokens();

    const { title = "", pendingSection = {}, failedSection = {} } = eChallanTransaction || {};

    return (
        <div styleName={"styles.wrapper"}>
            <Text size="400" fontWeight="semibold" color={tokens.text_Default_text_primary}>{title}</Text>
            <div styleName={"styles.boxWrapper"}>
                {pendingSection?.sectionData?.length > 0 && <StateChallanInfoCard title={pendingSection?.title} list={pendingSection?.sectionData} />}
                {failedSection?.sectionData?.length > 0 && <StateChallanInfoCard title={failedSection?.title} list={failedSection?.sectionData} />}
            </div>
        </div>
    );
};

StateEChallanTransaction.propTypes = {
    eChallanTransaction: PropTypes.object
};

export default StateEChallanTransaction;
